module.exports = __webpack_public_path__ + "img/fashion_48.e5a5c397.jpg";